import { useEffect, useState, useMemo } from 'react';
import { filterEmoji } from '../../../util/util';
import { useCustomTranslation } from '@/hooks/useCustomTranslation';
import If from '../../if/if';
import './posterForHistory.scss';

export default function posterForHistory(props) {
  const { t } = useCustomTranslation();

  const [posterInfo, updatePosterInfo] = useState({
    isShow:
      props.posterBox.posterArr.isShow !== undefined ? props.posterBox.posterArr.isShow : true,
    pictureImg: props.posterBox.posterArr.pic,
    pictureTitle: '',
    // flag: false,
    isFocus: props.posterBox.posterArr.isFocus,
    pictureEpisode: {
      type: 0,
      text: '',
    },
    pictureSubscript: {
      text: '',
    },
    watchProgress: '',
    indexValue: 0,
    posterAtion: undefined,
    isVip: false,
    isChecked: false,
    isOffShelf: false,
  });
  const isOffShelf = useMemo(() => posterInfo.isOffShelf, [posterInfo.isOffShelf]);
  const isShake = useMemo(() => (
    posterInfo.posterAtion === posterInfo.indexValue
  ), [posterInfo.posterAtion, posterInfo.indexValue]);

  useEffect(() => {
    const {
      posterBox: { posterAnimation, posterArr, posterIndex },
      isVip,
      // flag,
      isChecked,
    } = props;
    let pictureEpisode = {
      type: 0,
      text: '',
    };
    let pictureSubscript = {
      text: '',
    };
    if (posterArr.labels !== undefined) {
      const arr = Object.keys(posterArr.labels);
      if (arr.length) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] === '1') {
            pictureEpisode = posterArr.labels[arr[i]];
          }
          if (arr[i] === '0') {
            pictureSubscript = posterArr.labels[arr[i]];
          }
        }
      }
    }
    updatePosterInfo({
      isShow: posterArr.isShow !== undefined ? posterArr.isShow : true,
      pictureImg: posterArr.pic,
      pictureTitle: posterArr.subtitle || posterArr.title,
      // flag,
      isFocus: posterArr.isFocus,
      pictureEpisode,
      pictureSubscript,
      watchProgress: posterArr.watchProgress,
      indexValue: posterIndex,
      posterAtion: posterAnimation,
      isVip,
      isChecked,
      isOffShelf: posterArr.isOffShelf,
      // isOffShelf: true,
    });
  }, []);

  useEffect(() => {
    const {
      posterBox: { posterArr },
      // flag,
      isChecked,
    } = props;
    updatePosterInfo(posterInfo => ({
      ...posterInfo,
      isChecked,
      isFocus: posterArr.isFocus,
    }));
  }, [props.isChecked, props.posterBox.posterArr.isFocus]);

  useEffect(() => {
    updatePosterInfo(posterInfo => ({
      ...posterInfo,
      posterAtion: props.posterBox.posterAnimation,
    }));
  }, [props.posterBox.posterAnimation]);

  return (
    <div
      className={[
        'historyPoster',
        // posterInfo.posterAtion === posterInfo.indexValue ? 'posterShake' : null,
        isShake ? 'posterShake' : null,
        posterInfo.isVip ? 'vip' : 'notVip',
      ].join(' ')}
    >
      <div className="content_img">
        <img
          className={isOffShelf ? 'disable_img' : ''}
          src={posterInfo.isShow ? posterInfo.pictureImg : ''}
          alt=""
        />
        <If condition={isOffShelf}>
          <div className="disable_mask"></div>
        </If>
        {/* eslint-disable-next-line */}
        {posterInfo.isFocus ? null : (
          <div>
            <span
              className="Episode"
              style={{
                display: posterInfo.pictureEpisode.type === 1 && !isOffShelf ? 'inline-block' : 'none',
              }}
            >
              {t('全')}
              {posterInfo.pictureEpisode.text}
              {t('集')}
            </span>
            <span
              className="Episode"
              style={{
                display: posterInfo.pictureEpisode.type === 2 && !isOffShelf ? 'inline-block' : 'none',
              }}
            >
              {t('更新至')}
              {posterInfo.pictureEpisode.text}
              {t('集')}
            </span>
            <span className="describe1">
              {filterEmoji(posterInfo.pictureTitle || '')}
            </span>
            <span
              className="watchProgress"
              style={{
                display: posterInfo.pictureEpisode.type !== 0 ? 'inline-block' : 'none',
              }}
            >
              {/* eslint-disable-next-line */}
              {isOffShelf ? t('该内容暂不可播') : (
                (
                  posterInfo.watchProgress < 1
                    ? t('观看不足1%')
                    : `${t('观看至')}${posterInfo.watchProgress}%`
                )
              )}
            </span>
          </div>
        )}
        {posterInfo.pictureSubscript.text ? (
          <div
            className={[
              posterInfo.pictureSubscript.text === 'VIP' ? 'vipSubscript' : 'subscript',
            ].join(' ')}
          >
            {posterInfo.pictureSubscript.text}
          </div>
        ) : null}
      </div>
      {posterInfo.isFocus ? (
        <div
          className="foot_prompt"
          style={{
            backgroundColor: posterInfo.isVip === 'VIP' ? '#f9ebb1' : '#fff',
          }}
        >
          <div
            style={{ display: isOffShelf ? 'none' : 'block' }}
            className={[posterInfo.isVip === 'VIP' ? 'broadcast_v' : 'broadcast'].join(' ')}
          ></div>
          <div>
            <span
              className="pressure_Episode"
              style={{
                display: posterInfo.pictureEpisode.type === 1 && !isOffShelf ? 'inline-block' : 'none',
              }}
            >
              {t('全')}
              {posterInfo.pictureEpisode.text}
              {t('集')}
            </span>
            <span
              className="pressure_Episode"
              style={{
                display: posterInfo.pictureEpisode.type === 2 && !isOffShelf ? 'inline-block' : 'none',
              }}
            >
              {t('更新至')}
              {posterInfo.pictureEpisode.text}
              {t('集')}
            </span>
          </div>
          <span>
            {filterEmoji(posterInfo.pictureTitle || '')}
          </span>
          <span className={
            [
              'foot_Episode',
              isOffShelf ? 'offShelf' : null,
            ].join(' ')
          }>
            {/* eslint-disable-next-line */}
            {isOffShelf ? t('该内容暂不可播') : (
              (
                posterInfo.watchProgress < 1
                  ? t('观看不足1%')
                  : `${t('观看至')}${posterInfo.watchProgress}%`
              )
            )}
          </span>
        </div>
      ) : null}
    </div>
  );
}
